import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/modules/ui/components/card/Card';
import { Separator } from '@/modules/ui/components/separator/Separator';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

export const JobCardSkeleton = () => {
  return (
    <Card className="gap-2">
      <CardHeader>
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-2">
            <CardTitle>
              <Skeleton className="h-6 w-48" />
            </CardTitle>
            <Skeleton className="h-5 w-12 rounded-full" />
          </div>

          <CardAction>
            <Skeleton className="h-8 w-8 rounded-md" />
          </CardAction>
        </div>
      </CardHeader>

      <CardContent className="flex flex-col gap-4">
        <div className="flex gap-1">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-1" />
          <Skeleton className="h-4 w-24" />
        </div>

        <Separator orientation="horizontal" className="my-4 h-4" />

        <div className="flex items-center justify-between gap-2">
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </CardContent>
    </Card>
  );
};
